import React from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from "react-i18next";

interface SaveOrCancelButtonsProps {
    save: () => void,
    closeDialog: () => void;
}

function SaveOrCancelButtons(props: SaveOrCancelButtonsProps) {
    const { t } = useTranslation();

    return (
        <>
            <Button variant="primary" onClick={() => props.save()}>
                {t<string>("Application.Controls.Save")}
            </Button>
            <Button variant="secondary" onClick={props.closeDialog}>
                {t<string>("Application.Controls.Cancel")}
            </Button>
        </>
    );
}

export default SaveOrCancelButtons;